import { z } from "zod";
import { RequestMagicLinkMethodSchema } from "../Enums/RequestMagicLinkMethod";

export const StartMagicLinkProcessInputSchema = z.object({
    requestId: z.string(),
    method: RequestMagicLinkMethodSchema,
    recipient: z.string(),
});

export type StartMagicLinkProcessInput = z.infer<typeof StartMagicLinkProcessInputSchema>;

